<top-banner variant="title" [title]="selectedSite?.name"></top-banner>

<div class="main-content work-order-form-page procedure-details-page">
  <div class="row">
    <div class="col-md-12">
      <div class="card">
        <div class="row">
          <div class="col-md-2 cardtabs-wrapper">
            <app-site-tab-menu
              [site]="selectedSite"
              [optTitle]="procedure ? { from: selectedProcedureId, to: 'PRC' + procedure.id } : null">
            </app-site-tab-menu>
          </div>

          <div class="col-md-10">
            <div class="card-body" *ngIf="!loading && procedure; else procedureDetailsLoading">
              <div class="procedure-details-header">
                <div>
                  <card-section-header title="Procedure Details" icon="fas fa-list"></card-section-header>
                  <h4 class="procedure-code">Procedure: PRC{{ procedure.id }}</h4>
                  <p class="procedure-description">{{ procedure.name }}: {{ procedure.description }}</p>
                </div>

                <div class="procedure-top-actions">
                  <button type="button" class="btn color_blue-btn btn-round procedure-primary-action" (click)="navigateToCreateWorkOrder()">
                    <i class="fas fa-plus"></i>
                    &nbsp;
                    <strong>CREATE WORK ORDER</strong>
                  </button>
                  <button type="button" class="btn btn-primary btn-link procedure-secondary-action" (click)="navigateToEditProcedure()">
                    <span><i class="fas fa-edit"></i></span>
                    Edit Details
                  </button>
                  <button type="button" class="btn btn-link text-danger procedure-secondary-action" [disabled]="deleting" (click)="deleteProcedure()">
                    <i class="fas fa-times"></i>
                    Delete
                  </button>
                </div>
              </div>

              <div class="procedure-meta-grid">
                <div>Minimum Work Party Size: <span class="procedure-meta-value">{{ procedure.minimumPartySize || '-' }}</span></div>
                <div>Revision: <span class="procedure-meta-value">{{ procedure.revision || '-' }}</span></div>
                <div class="procedure-meta-muted">Created by: {{ procedure.createdBy || '-' }}</div>
                <div class="procedure-meta-muted">Last Updated: {{ procedure.lastModifiedDate | date: 'd MMM yyyy HH:mm' }}</div>
              </div>

              <div class="procedure-details-desktop">
                <ul class="nav nav-tabs procedure-detail-tabs">
                  <li class="nav-item">
                    <a class="nav-link" [class.active]="activeTab === 'asset'" (click)="setActiveTab('asset')">Asset</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" [class.active]="activeTab === 'competencies'" (click)="setActiveTab('competencies')">Competencies</a>
                  </li>
                  <li class="nav-item">
                    <a class="nav-link" [class.active]="activeTab === 'documents'" (click)="setActiveTab('documents')">Documents</a>
                  </li>
                </ul>

                <div class="procedure-detail-panel" *ngIf="activeTab === 'asset'">
                  <ng-container *ngTemplateOutlet="assetCategoryContent"></ng-container>
                </div>

                <div class="procedure-detail-panel" *ngIf="activeTab === 'competencies'">
                  <div class="competencies-content procedure-competencies-panel">
                    <div class="mb-5">
                      <div class="competency-section-header">
                        <p><i class="fas fa-user"></i> Lead Worker</p>
                        <div class="button-link-wrapper">
                          <button type="button" class="btn btn-primary btn-link" (click)="onEditCompetencies('LEAD')">
                            <span><i class="fas fa-plus"></i></span> Add Competency
                          </button>
                        </div>
                      </div>
                      <div class="sl-accordion-content-overflow-wrapper procedure-competency-grid-wrapper">
                        <div class="competency-card-grid" *ngIf="hasCompetenciesFor('LEAD'); else noLeadWorkerCompetenciesDesktop">
                          <competency-card
                            *ngFor="let competency of leadWorkerCompetencies"
                            [competency]="competency"
                            cardType="work-order-edit"
                            (delete)="onCompetencyDelete($event)">
                          </competency-card>
                        </div>
                      </div>
                      <ng-template #noLeadWorkerCompetenciesDesktop>
                        <p class="procedure-empty-state">No lead worker competencies linked to this procedure.</p>
                      </ng-template>
                    </div>

                    <div>
                      <div class="competency-section-header">
                        <p><i class="fas fa-users"></i> All Workers</p>
                        <div class="button-link-wrapper">
                          <button type="button" class="btn btn-primary btn-link" (click)="onEditCompetencies('ALL')">
                            <span><i class="fas fa-plus"></i></span> Add Competency
                          </button>
                        </div>
                      </div>
                      <div class="sl-accordion-content-overflow-wrapper procedure-competency-grid-wrapper">
                        <div class="competency-card-grid" *ngIf="hasCompetenciesFor('ALL'); else noAllWorkerCompetenciesDesktop">
                          <competency-card
                            *ngFor="let competency of allWorkerCompetencies"
                            [competency]="competency"
                            cardType="work-order-edit"
                            (delete)="onCompetencyDelete($event)">
                          </competency-card>
                        </div>
                      </div>
                      <ng-template #noAllWorkerCompetenciesDesktop>
                        <p class="procedure-empty-state">No all worker competencies linked to this procedure.</p>
                      </ng-template>
                    </div>
                  </div>
                </div>

                <div class="procedure-detail-panel" *ngIf="activeTab === 'documents'">
                  <ng-container *ngTemplateOutlet="documentsContent"></ng-container>
                </div>
              </div>

              <div class="procedure-details-mobile">
                <div class="sl-accordion">
                  <sl-accordion-section title="Asset">
                    <div class="procedure-detail-panel mobile-panel">
                      <ng-container *ngTemplateOutlet="assetCategoryContent"></ng-container>
                    </div>
                  </sl-accordion-section>

                  <sl-accordion-section title="Competencies">
                    <div class="procedure-detail-panel mobile-panel">
                      <div class="competencies-content procedure-competencies-panel">
                        <div class="mb-5">
                          <div class="competency-section-header">
                            <p><i class="fas fa-user"></i> Lead Worker</p>
                            <div class="button-link-wrapper">
                              <button type="button" class="btn btn-primary btn-link" (click)="onEditCompetencies('LEAD')">
                                <span><i class="fas fa-plus"></i></span> Add Competency
                              </button>
                            </div>
                          </div>
                          <div class="sl-accordion-content-overflow-wrapper procedure-competency-grid-wrapper">
                            <div class="competency-card-grid" *ngIf="hasCompetenciesFor('LEAD'); else noLeadWorkerCompetenciesMobile">
                              <competency-card
                                *ngFor="let competency of leadWorkerCompetencies"
                                [competency]="competency"
                                cardType="work-order-edit"
                                (delete)="onCompetencyDelete($event)">
                              </competency-card>
                            </div>
                          </div>
                          <ng-template #noLeadWorkerCompetenciesMobile>
                            <p class="procedure-empty-state">No lead worker competencies linked to this procedure.</p>
                          </ng-template>
                        </div>

                        <div>
                          <div class="competency-section-header">
                            <p><i class="fas fa-users"></i> All Workers</p>
                            <div class="button-link-wrapper">
                              <button type="button" class="btn btn-primary btn-link" (click)="onEditCompetencies('ALL')">
                                <span><i class="fas fa-plus"></i></span> Add Competency
                              </button>
                            </div>
                          </div>
                          <div class="sl-accordion-content-overflow-wrapper procedure-competency-grid-wrapper">
                            <div class="competency-card-grid" *ngIf="hasCompetenciesFor('ALL'); else noAllWorkerCompetenciesMobile">
                              <competency-card
                                *ngFor="let competency of allWorkerCompetencies"
                                [competency]="competency"
                                cardType="work-order-edit"
                                (delete)="onCompetencyDelete($event)">
                              </competency-card>
                            </div>
                          </div>
                          <ng-template #noAllWorkerCompetenciesMobile>
                            <p class="procedure-empty-state">No all worker competencies linked to this procedure.</p>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </sl-accordion-section>

                  <sl-accordion-section title="Documents">
                    <div class="procedure-detail-panel mobile-panel">
                      <ng-container *ngTemplateOutlet="documentsContent"></ng-container>
                    </div>
                  </sl-accordion-section>
                </div>
              </div>
            </div>

            <ng-template #documentsContent>
              <div class="procedure-documents-panel">
                <div class="procedure-document-section" *ngIf="allowCompulsoryCheckOnSiteForm && siteFormsOptions.length">
                  <h5>Check-on Site Form</h5>
                  <div class="procedure-document-editor">
                    <label>Select Compulsory Check-On Site Form</label>
                    <div class="procedure-document-editor-row">
                      <p-dropdown
                        class="form-control sl-input procedure-document-dropdown"
                        [options]="siteFormsOptions"
                        [(ngModel)]="selectedCheckOnSiteForm"
                        optionLabel="label"
                        placeholder="Select site form..."
                        [style]="{ width: '100%' }"
                        [filter]="true"
                        [disabled]="checkOnSiteFormSaving">
                      </p-dropdown>
                      <button
                        type="button"
                        class="btn btn-success btn-round procedure-document-action"
                        [disabled]="checkOnSiteFormSaving"
                        (click)="saveCheckOnSiteForm()">
                        Save
                      </button>
                    </div>
                  </div>

                  <div class="procedure-document-list">
                    <div class="procedure-document-list-row" *ngIf="procedure.checkOnSiteFormName; else noCheckOnSiteForm">
                      <span>{{ procedure.checkOnSiteFormName }}</span>
                      <div class="file-list-links">
                        <button type="button" class="btn btn-primary btn-link" (click)="viewCheckOnSiteForm()">
                          <i class="fas fa-search"></i>
                          View
                        </button>
                        <button
                          type="button"
                          class="btn btn-link text-danger procedure-remove-link"
                          [disabled]="checkOnSiteFormSaving"
                          (click)="removeCheckOnSiteForm()">
                          <i class="fas fa-times"></i>
                          Remove
                        </button>
                      </div>
                    </div>
                    <ng-template #noCheckOnSiteForm>
                      <div class="procedure-document-list-row empty">
                        <span>No Form Selected</span>
                      </div>
                    </ng-template>
                  </div>
                </div>

                <div class="procedure-document-section" *ngIf="allowCompulsoryCheckOffSiteForm && siteFormsOptions.length">
                  <h5>Check-off Site Form</h5>
                  <div class="procedure-document-editor">
                    <label>Select Compulsory Check-Off Site Form</label>
                    <div class="procedure-document-editor-row">
                      <p-dropdown
                        class="form-control sl-input procedure-document-dropdown"
                        [options]="siteFormsOptions"
                        [(ngModel)]="selectedCheckOffSiteForm"
                        optionLabel="label"
                        placeholder="Select site form..."
                        [style]="{ width: '100%' }"
                        [filter]="true"
                        [disabled]="checkOffSiteFormSaving">
                      </p-dropdown>
                      <button
                        type="button"
                        class="btn btn-success btn-round procedure-document-action"
                        [disabled]="checkOffSiteFormSaving"
                        (click)="saveCheckOffSiteForm()">
                        Save
                      </button>
                    </div>
                  </div>

                  <div class="procedure-document-list">
                    <div class="procedure-document-list-row" *ngIf="procedure.checkOffSiteFormName; else noCheckOffSiteForm">
                      <span>{{ procedure.checkOffSiteFormName }}</span>
                      <div class="file-list-links">
                        <button type="button" class="btn btn-primary btn-link" (click)="viewCheckOffSiteForm()">
                          <i class="fas fa-search"></i>
                          View
                        </button>
                        <button
                          type="button"
                          class="btn btn-link text-danger procedure-remove-link"
                          [disabled]="checkOffSiteFormSaving"
                          (click)="removeCheckOffSiteForm()">
                          <i class="fas fa-times"></i>
                          Remove
                        </button>
                      </div>
                    </div>
                    <ng-template #noCheckOffSiteForm>
                      <div class="procedure-document-list-row empty">
                        <span>No Form Selected</span>
                      </div>
                    </ng-template>
                  </div>
                </div>

                <div class="procedure-document-section">
                  <h5>Documents / RAMS</h5>
                  <div class="procedure-document-editor rams-group">
                    <label>Upload Documents / RAMS</label>
                    <div class="procedure-document-editor-row">
                      <div class="rams-control procedure-document-upload-row">
                        <div class="rams-upload" (click)="procedureDocumentsInput.click()">
                          <span class="rams-placeholder" *ngIf="!selectedDocuments.length">Choose document...</span>
                          <span class="rams-placeholder" *ngIf="selectedDocuments.length">{{ selectedDocuments.length }} file(s) selected</span>
                          <i class="pi pi-upload"></i>
                        </div>
                        <input
                          #procedureDocumentsInput
                          type="file"
                          class="rams-file-input"
                          accept=".pdf, image/*, .doc, .docx, .ppt, .pptx, .pps, .ppsx, .odt, .xls, .xlsx, .key"
                          (change)="onDocumentsChange($event)"
                          multiple
                        />
                      </div>
                      <button
                        type="button"
                        class="btn btn-success btn-round procedure-document-action"
                        [disabled]="!selectedDocuments.length || documentSaving"
                        (click)="addDocuments()">
                        Add
                      </button>
                    </div>
                  </div>

                  <div class="procedure-document-list" *ngIf="procedure.files?.length; else noDocuments">
                    <div class="procedure-document-list-row" *ngFor="let file of procedure.files">
                      <span>{{ file.fileName }}</span>
                      <div class="file-list-links">
                        <button type="button" class="btn btn-primary btn-link" (click)="viewDocument(file.fileName)">
                          <i class="fas fa-search"></i>
                          View
                        </button>
                        <button
                          type="button"
                          class="btn btn-link text-danger procedure-remove-link"
                          [disabled]="deletingDocumentId === file.id"
                          (click)="deleteDocument(file.id)">
                          <i class="fas fa-times"></i>
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                  <ng-template #noDocuments>
                    <div class="procedure-document-list">
                      <div class="procedure-document-list-row empty">
                        <span>No Documents Uploaded</span>
                      </div>
                    </div>
                  </ng-template>
                </div>
              </div>
            </ng-template>

            <ng-template #assetCategoryContent>
              <h5>Asset Category</h5>
              <div class="procedure-asset-editor">
                <label>Select Asset Category</label>
                <div class="procedure-asset-editor-row">
                  <p-dropdown
                    class="form-control sl-input procedure-asset-dropdown"
                    [options]="assetCategories"
                    [(ngModel)]="selectedAssetCategory"
                    optionLabel="label"
                    placeholder="Select asset category..."
                    [style]="{ width: '100%' }"
                    [filter]="true"
                    [disabled]="assetCategoriesLoading || assetCategorySaving">
                  </p-dropdown>
                  <button
                    type="button"
                    class="btn btn-success btn-round procedure-asset-save"
                    [disabled]="!selectedAssetCategory || assetCategorySaving"
                    (click)="saveAssetCategory()">
                    Save
                  </button>
                </div>
              </div>

              <div class="procedure-asset-list" *ngIf="procedure.assetCategory; else noAssetCategory">
                <div class="procedure-asset-list-row">
                  <span
                    class="badge badge-pill badge-success detail-chip"
                    [ngStyle]="{ 'background-color': procedure.assetCategory.color }">
                    {{ procedure.assetCategory.name }}
                  </span>
                </div>
              </div>

              <ng-template #noAssetCategory>
                <div class="procedure-asset-list empty">
                  <p>No asset category linked.</p>
                </div>
              </ng-template>
            </ng-template>

            <ng-template #procedureDetailsLoading>
              <div class="card-body">
                <div class="row form-row">
                  <div class="col-md-6">
                    <skeleton-loading-field></skeleton-loading-field>
                  </div>
                  <div class="col-md-6">
                    <skeleton-loading-field></skeleton-loading-field>
                  </div>
                </div>
                <div class="row form-row">
                  <div class="col-md-12">
                    <skeleton-loading-field variant="textarea"></skeleton-loading-field>
                  </div>
                </div>
                <div class="row form-row">
                  <div class="col-md-12">
                    <skeleton-loading-field></skeleton-loading-field>
                  </div>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
